import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Schools(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M23.5 17.382a.985.985 0 00-.5-.847v-7.29l.384-.19a1.116 1.116 0 000-1.995L12.499 1.618a1.116 1.116 0 00-.998 0L.616 7.06a1.116 1.116 0 000 1.995L11.5 14.497c.314.157.684.157.998 0l9.5-4.751v6.789a.985.985 0 00-.5.847c0 .39.23.72.558.885L21 20.382h3l-1.057-2.115a.991.991 0 00.557-.885zm-11.083-.672a1.114 1.114 0 01-.997 0L3 12.5v4.311a2.23 2.23 0 001.232 1.994l6.689 3.345a2.23 2.23 0 001.995 0l6.689-3.345a2.23 2.23 0 001.232-1.994V12.5l-8.42 4.21z"
  }));
}

export { Schools };
//# sourceMappingURL=Schools.js.map